import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Home from "./Components/Home/Home";
import Blog from "./Components/Blog/Blog";
import Skills from "./Components/Skills/Skills";
// import Projects from "./Components/Projects/Projects";
import Navbar from "./Components/Navbar/Navbar";
import "./App.css";
import "../node_modules/video-react/dist/video-react.css";

function App() {
  return (
    <div>
      <Router>
        <Navbar />
        <AnimatePresence>
          <Route path="/" exact>
            <Skills />
          </Route>
          <Route path="/blogs">
            <Home />
          </Route>
          <Route path="/blog">
            <Blog />
          </Route>
        </AnimatePresence>
      </Router>
    </div>
  );
}

export default App;
